import React from "react";
import CheckBox from "common/ui/components/fields/CheckBox";
import SimpleModal from "common/ui/components/modal/SimpleModal";
import * as appRouting from "appRouting";
import { Link } from "react-router";
import FieldString from "common/ui/components/fields/FieldString";
import HoverInfoWrapper from "common/ui/components/tooltips/HoverInfoWrapper";
import HoverInfoLeadsBreakdown from "common/ui/components/tooltips/HoverInfoLeadsBreakdown";
import * as ReportHelper from "common/utils/reportHelper";
import DateHelper from "common/utils/DateHelper";
//import { TotalLeadsBreakdown } from "agency/reports/overview/selector";
//--
import styles from "./RenderAs.less";
//--
export const renderAsLongText = ({ data }) => {
    return (React.createElement("div", null,
        React.createElement("span", null, data)));
};
export const renderAsEmail = ({ data }) => {
    return (React.createElement("div", null,
        React.createElement("a", { href: `mailto:${data}` }, data)));
};
export const renderAsCommaSeperated = ({ data }) => {
    return (React.createElement("div", null,
        React.createElement("span", null, data.join(", "))));
};
export const renderAsTick = ({ data }) => {
    if (data) {
        return React.createElement(CheckBox, { defaultChecked: true });
    }
    return React.createElement(CheckBox, { defaultChecked: false });
};
export const renderAsDate = ({ data }) => {
    return React.createElement("span", null, DateHelper.parseDateToString(data));
};
export const renderAsFormattedNumber = ({ data }) => {
    return React.createElement("span", null, ReportHelper.formatBigNumber(data));
};
export const renderAsTotalLeadsWithBreakdown = ({ rowData }) => {
    const { officeId, totalTelephoneLeads, totalMessageLeads, totalOtherLeads, totalLeads } = rowData;
    return (React.createElement(HoverInfoLeadsBreakdown, { id: `TotalLeads${officeId}`, telephoneLeads: totalTelephoneLeads, messageLeads: totalMessageLeads, otherLeads: totalOtherLeads, totalLeads: totalLeads }));
};
export const renderAsSalesTotalLeadsWithBreakdown = ({ rowData }) => {
    const { officeId, totalSaleTelephoneLeads, totalSaleMessageLeads, totalSaleLeads } = rowData;
    return (React.createElement(HoverInfoLeadsBreakdown, { id: `TotalSalesLeads${officeId}`, telephoneLeads: totalSaleTelephoneLeads, messageLeads: totalSaleMessageLeads, totalLeads: totalSaleLeads }));
};
export const renderAsRentalsTotalLeadsWithBreakdown = ({ rowData }) => {
    const { officeId, totalRentalTelephoneLeads, totalRentalMessageLeads, totalRentalLeads } = rowData;
    return (React.createElement(HoverInfoLeadsBreakdown, { id: `TotalRentalLeads${officeId}`, telephoneLeads: totalRentalTelephoneLeads, messageLeads: totalRentalMessageLeads, totalLeads: totalRentalLeads }));
};
export const renderAsRand = ({ data }) => {
    return React.createElement("span", null,
        "R ",
        ReportHelper.formatBigNumber(data));
};
export const renderAsPercent = ({ data }) => {
    return React.createElement("span", null,
        data,
        "%");
};
export const renderAsListingLink = ({ rowData }) => {
    const { portalRef } = rowData;
    return (React.createElement("a", { href: `${listingRedirectUrl}${portalRef}`, target: "_blank" }, portalRef));
};
export const renderAsOfficeLink = (props) => {
    const { officeName, officeId } = props.rowData;
    return (React.createElement(HoverInfoWrapper, { tipText: officeName }, officeId ?
        React.createElement(Link, { to: appRouting.officeReportsUrl(officeId) }, officeName) :
        React.createElement("span", null, officeName)));
};
export const renderAsClickableModal = (props) => {
    let text = props.data;
    let escaped = text.replace(/(\\n\\n)|(\\n)|(\\r\\n)/g, '\n');
    const getLeadInfo = (rowData) => {
        return (React.createElement("div", null,
            React.createElement(FieldString, { label: "From", labelWidth: 75, value: rowData.fromName }),
            React.createElement(FieldString, { label: "Email", labelWidth: 75, value: rowData.fromEmail }),
            React.createElement(FieldString, { label: "Cell", labelWidth: 75, value: rowData.fromMobile }),
            React.createElement(FieldString, { label: "Sent On", labelWidth: 75, value: rowData.date })));
    };
    const getLeadAddress = (rowData) => {
        if (rowData.portalRef != null) {
            return (React.createElement(FieldString, { label: "Re", labelWidth: 75, value: `${rowData.listingAddress} (${rowData.portalRef})` }));
        }
        else {
            return (React.createElement(FieldString, { label: "Re", labelWidth: 75, value: `Direct to ${rowData.toName}` }));
        }
    };
    const { rowData } = props;
    return React.createElement(SimpleModal, { modalTitle: "Lead Details", action: "link", actionText: escaped, shownByDefault: false },
        getLeadInfo(rowData),
        React.createElement("div", { className: styles.messageArea },
            getLeadAddress(rowData),
            React.createElement("textarea", { disabled: true, className: styles.textArea, value: escaped })));
};
export const renderAsNoData = () => {
    return React.createElement("div", { className: "noTableResults" }, "No results found.");
};
